import App from '@components/sliders/review/reviewCarousel.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';
const injections = [{
  name: 'locale',
  module: locale
},{
  name: '$axios',
  module: generateAxiosInstance()
}]
const props = {
  reviews: reviews,
}
generateApplication(App, "#review-carousel", { injections, props })